import * as React from "react";
function SvgArrowsReduce(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path
          className="arrows-reduce_svg__st0"
          d="M1 16h12l-4 4M23 12l-4 4h12M9 12l4 4M19 16l4 4"
        />
      </g>
      {"g"}
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowsReduce);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
